import { type GetPositionFn } from '..'

export const getBottomPosition: GetPositionFn<'bottom'> = (targetOptions, context) => {
  const target = context.detailsTargetMap.get('bottom')
  if (target == null) {
    throw new Error('Bottom target is not initialized, but is required by details.')
  }
  const elBounding = target.getElementBounding()

  if (elBounding != null) {
    return {
      elementBounding: {
        top: elBounding.top.value,
        left: elBounding.left.value,
        width: elBounding.width.value,
        height: elBounding.height.value
      }
    }
  }
  throw new Error('Unknown details position')
}
